import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {STATUSES_DEVICE_ACTIVITY} from "@containers/device/containers/deviceActivity/constants";
import SelectCustom from "@ui/select/selectCustom/SelectCustom";
import {StatusDeviceActivity} from "@containers/device/containers/deviceActivity/types";
import {SxType} from "@baseTypes/sx/sxTypes";


interface IProps {
    value: StatusDeviceActivity | '0',
    onChange: (value: StatusDeviceActivity | '0') => void,
    width?: number | string | SxType,
    disabled?: boolean,
    hasAllVariant?: boolean
}

const SelectStatusDeviceActivity = ({
                                        value,
                                        onChange,
                                        width,
                                        disabled,
                                        hasAllVariant
                                    }: IProps) => {

    const {t} = useTranslation()
    const dataSelect = useMemo(() => {
        const arr = STATUSES_DEVICE_ACTIVITY.map((item) => {
            return {
                value: item.value,
                label: t(item.label)
            }
        })
        if(!hasAllVariant){
            return  arr
        }
        return [
            {
                label: t('base.all'),
                value: '0'
            },
            ...arr,
        ]

    }, [hasAllVariant])

    return (
        <SelectCustom
            <StatusDeviceActivity>
            value={value}
            onChange={onChange}
            label={t('base.status')}
            data={dataSelect}
            width={width}
            disabled={disabled}
        />
    )
};

export default SelectStatusDeviceActivity;